import { Box, Typography } from '@mui/material';
import OfferDiscountIcon from '@/assets/offers/OfferDiscountIcon.svg';
import FlexBox from '@/atomic-components/FlexBox';
import { getStyle } from '@/utils/theme/fonts';

import { SelectedOffer } from '../VerticalCart';
import LencoButton from '@/atomic-components/LencoButton';
import { getColor } from '@/utils/theme/colors';
import LinearProgress, {
	linearProgressClasses,
} from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { emitMoeEvent } from '@/utils/dataLayer';

import { CART_TYPE } from '@/services/cart/models/cart';

type OfferTileProps = {
	rentOffer: any;
	isDrawer?: boolean;
	isTermConditionsVisible?: boolean;
	offerAppliedCart?: any;
	openTermConditions?: any;
	rentCart?: any;
	applyOfferToCart: (selectedOffer: SelectedOffer, cartType: CART_TYPE) => void;
	removingCouponCode?: boolean;
	onRemove?: (e: any) => void;
	offerClicked?: any;
	isnonApplicableOffers?: boolean;
	isApplied?: boolean;
	cartType: any;
	openOffersListDrawer?: any;
};
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
	height: 10,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: '#fff',
		border: '1.8px solid white',
		height: '10px !important',
	},
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,

		backgroundColor: '#ED9F23',
	},
}));

const OfferTile = (props: OfferTileProps) => {
	return (
		<FlexBox
			direction='column'
			justifyContent='start'
			gap={'8px'}
			alignItems='start'
			sx={{
				backgroundColor: props.isnonApplicableOffers ? '#F3F3F3' : '#FFF5B7',
				padding: '16px',
				paddingBottom: props?.isTermConditionsVisible ? '20px' : '12px',
				borderRadius: '12px',
				height: 'max-content',
				minWidth: '280px',
				maxWidth: '350px',
			}}
		>
			<FlexBox alignItems='start' fullWidth gap={'12px'}>
				<Box sx={{ height: '16px', width: '16px', mt: '3px' }}>
					<OfferDiscountIcon />
				</Box>
				<FlexBox direction='column' gap={'4px'} width='100%'>
					<Typography
						sx={{
							...getStyle('P_Medium'),
							width: '97%',

							color: props.isnonApplicableOffers ? '#777' : '#000',
						}}
					>
						{props?.rentOffer?.header}
					</Typography>
					{(props?.isnonApplicableOffers && props.rentOffer?.progressBar?.progress)  && (
						<FlexBox alignItems='center' gap={'8px'} direction='column'>
							<Box sx={{ width: '100%', textAlign: 'end' }}>
								<BorderLinearProgress
									variant='determinate'
									value={props.rentOffer?.progressBar?.progress}
								/>
							</Box>
							{/* <FlexBox
								gap={'4px'}
								sx={{ ...getStyle('Tiny_Medium'), color: '#AA6311' }}
							>
								{props?.rentOffer?.progressBar?.deficitAmount?.displayValue}{' '}
								<span>more</span>
							</FlexBox> */}
							<Box>
								<Typography
									sx={{
										...getStyle('Tiny_Medium'),
										color: '#AA6311',
									}}
								>
									{props?.rentOffer?.progressBar?.message?.primary}
								</Typography>
							</Box>
						</FlexBox>
					)}
				</FlexBox>
			</FlexBox>

			<FlexBox
				width='100%'
				justifyContent='center'
				alignItems='center'
				sx={{
					backgroundColor: getColor(''),
					position: 'relative',
					padding: '7px 22px',
					borderRadius: '4px',
					border: `1px dashed ${
						props.isnonApplicableOffers ? '#777777' : '#997D21'
					}`,
					':before': {
						content: '""',
						height: '21px',
						background: props.isnonApplicableOffers
							? getColor('Gray -6')
							: getColor('Yellow -3'),
						border: `1px dashed ${
							props.isnonApplicableOffers ? '#997D21' : '#777777'
						}`,
						borderLeftWidth: '0px',
						borderBottomWidth: '0px',
						borderTopWidth: '0px',
						width: '21px',
						position: 'absolute',
						top: '20%',
						left: '-4%',
						borderRadius: '50%',
					},
					':after': {
						content: '""',
						height: '21px',
						background: props.isnonApplicableOffers
							? getColor('Gray -6')
							: getColor('Yellow -3'),
						border: `1px dashed ${
							props.isnonApplicableOffers ? '#997D21' : '#777777'
						}`,
						borderRightWidth: '0px',
						borderBottomWidth: '0px',
						borderTopWidth: '0px',
						width: '21px',
						position: 'absolute',
						top: '20%',
						right: '-4%',
						borderRadius: '50%',
					},
				}}
			>
				<FlexBox
					fullWidth
					justifyContent='space-between'
					alignItems='center'
					sx={{
						padding: '0px 12px 0px 14px',
					}}
				>
					<Typography
						sx={{
							color: props.isApplied
								? getColor('Success +1')
								: props.isnonApplicableOffers
								? '#777'
								: '#000',
							...getStyle('Small_Medium'),
						}}
					>
						{props?.rentOffer?.code}
					</Typography>
					<FlexBox alignItems='center'>
						<LencoButton
							sx={{
								textTransform: 'none',
								color: props.isApplied
									? getColor('Success +1')
									: props.isnonApplicableOffers
									? '#777'
									: '#000',

								...getStyle('Small_SemiBold'),
								textDecoration: props.isApplied ? 'none' : 'underline',
								padding: '0px',
								justifyContent: 'end !important',
							}}
							disabled={props?.isnonApplicableOffers}
							onClick={() =>
								props.applyOfferToCart(
									{
										code: props?.rentOffer?.code,
										id: props?.rentOffer?.id,
									},
									props.cartType
								)
							}
						>
							{props.isApplied ? 'Applied' : props?.rentOffer?.cta}
						</LencoButton>
						{props.isApplied && (
							<LencoButton
								onClick={props.onRemove}
								isLoading={props.removingCouponCode}
								sx={{
									minWidth: '20px !important',
									cursor: 'pointer',
									color: getColor('Success +1'),
									padding: '0px',
									width: '20px !important',
								}}
							>
								x
							</LencoButton>
						)}
					</FlexBox>
				</FlexBox>
			</FlexBox>
			{!props?.isTermConditionsVisible && (
				<Typography
					sx={{
						textDecoration: 'underline',
						mt: '4px',
						cursor: 'pointer',
						width: '100%',
						textAlign: 'end',
						...getStyle('Tiny_Regular'),
						color: getColor('gray -2'),
					}}
					onClick={() => {
						props?.offerClicked(props?.rentOffer);
						emitMoeEvent('Offers Tncs Clicked', {
							discount_id: props?.rentOffer?.id,
							discount_name: props?.rentOffer?.code,
						});
					}}
				>
					*Terms and Conditions
				</Typography>
			)}
		</FlexBox>
	);
};

export default OfferTile;
